import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ApartmentRounded, AttachMoneyRounded, ArrowDropDownCircleOutlined, MapOutlined, Info } from '@mui/icons-material';
import SchoolIcon from '@mui/icons-material/School';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState, useEffect } from 'react';
import { getQuestionnaires } from '../../repo/firebaseFunctions';
import { CircularProgress } from '@mui/material';




function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-ta   bpanel-${index}`,
    };
}


export default function TeacherProfileTabs(props) {
  const [isLoading, setIsLoading] = useState(true);
    const [value, setValue] = React.useState(0);
    const [reviews, setReviews] = React.useState([]);
    
    

    useEffect(() => {
      async function fetchData() {
        const s = await getQuestionnaires('001',props.teacher.uid); 

        setReviews(s)
        setIsLoading(false);
        console.log(s);
      }
      fetchData();
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    return (
        <Box>
            <Tabs value={value} onChange={handleChange} aria-label="icon label tabs example" style={{ maxHeight: '100vh', display: "flex", justifyContent: "center", alignItems: "center",  }} sx={{
          justifyContent: "center",
        }}>
                <Tab sx={{
          justifyContent: "center",
        }} icon={<Info />} label="About" {...a11yProps(0)} />
                <Tab sx={{
          justifyContent: "center",
        }} icon={<ArrowDropDownCircleOutlined />} label="Teacher Analysis" {...a11yProps(1)} />
            </Tabs>

            <TabPanel value={value} index={0}  sx={{
          justifyContent: "center",
        }}
>
            <Box sx={{ p: 3 }}>
          <Typography variant="h6" mb={2}>
            Teacher Information
          </Typography>
          <Typography variant="subtitle1" mb={1}>
            Name: {props.teacher.name}
          </Typography>
          <Typography variant="subtitle1" mb={1}>
            Email: {props.teacher.email}
          </Typography>
          <Typography variant="subtitle1" mb={1}>
            DOB: {props.teacher.dob}
          </Typography>
          <Typography variant="subtitle1" mb={1}>
            Class: {props.teacher.courseID}
          </Typography>
          
        </Box>
      </TabPanel>

      <TabPanel value={value} index={1}     sx={{
          justifyContent: "center",
        }}
>
  <>
  Teacher rating based on the student reviews: 
  {
          isLoading
          ? <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '30%' }}>
          <CircularProgress />
        </div>
          :reviews.map((e)=>{
            return <>
             <Typography>
              {toString(e.percentage)}
            </Typography>
            <Typography>
            {e.comment}
          </Typography>
            </>
           
          })
        }
  </>
        

      </TabPanel>
            
            
        </Box>


    );
}
